import React, { useState } from "react";
import {
  Form,
  Row,
  Col,
  Input,
  Button,
  Card,
  DatePicker,
  Select,
  Upload,
  message,
  Spin,
  Skeleton,
  Table,
  Divider,
} from "antd";
import IntlMessages from "../../../util/IntlMessages";
import UploadOutlined from "@ant-design/icons/lib/icons/UploadOutlined";
import ds from "../../../Services/DataServices";
import { BEHAVIOUR_TYPE } from "../../../Services/DataServices";
import { IntlProvider } from "react-intl";
import { useHistory } from "react-router-dom";
import { useDispatch, useStore } from "react-redux";
import { userLogOut } from "../../../appRedux/actions/Auth";
import { notAllowMsgCheck } from "../../../appRedux/actions";

const ProductDetail = ({ match }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const store = useStore();
  const [form] = Form.useForm();
  const [getOutletData, setOutletData] = React.useState([]);
  const [getCustomersData, setCustomersData] = React.useState([]);
  const [isSpinningLoading, setSpinningLoading] = React.useState(true);
  const [isTableLoading, setTableLoading] = React.useState(false);
  const [getProdName, setProdName] = React.useState("");
  const [getProdDesc, setProdDesc] = React.useState("");
  const [getBrandName, setBrandName] = React.useState("");
  const [getProdTags, setProdTags] = React.useState([]);
  const [getProdInventType, setProdInventType] = React.useState("");
  const [getIsCustomSKU, setIsCustomSKU] = React.useState(false);
  const [getCustomSKUCode, setCustomSKUCode] = React.useState("");
  const [getNoOFVariant, setNoOFVariant] = React.useState("");
  const [getSupplierID, setSupplierID] = React.useState(0);
  const [getSupplierCode, setSupplierCode] = React.useState("");
  const [getSupplierPrice, setSupplierPrice] = React.useState("");
  const [getIsProdInventory, setIsProdInventory] = React.useState(false);
  const [getOutletInventoryAndTax, setOutletInventoryAndTax] = React.useState(
    []
  );
  const [getCompositeProductsData, setCompositeProductsData] = React.useState(
    []
  );
  const [getMarkupInPercentage, setMarkupInPercentage] = React.useState("");
  const [getRetailPrice, setRetailPrice] = React.useState("");
  const [getIsCustomLoyalty, setIsCustomLoyalty] = React.useState(false);
  const [getName, setName] = React.useState("");
  const [getLoyaltyPrice, setLoyaltyPrice] = React.useState("");
  const [getVariantName, setVariantName] = React.useState("");
  const [getIsVariant, setIsVariant] = React.useState(false);
  const [getProductVariants, setProductVariants] = React.useState([]);
  const [getVariantAttributes, setVariantAttributes] = React.useState([]);
  const [getProductID, setProductID] = React.useState("");

  //const [getDefaultOut, setDefaultOut] = React.useState('Select Outlet');
  //const [getDefaultCus, setDefaultCus] = React.useState('');

  React.useEffect(() => {
    let url = window.location.href.split("productdetail/");
    let id = url.length > 1 ? url[1] : false;
    if (id) {
      setProductID(id);
      getProductsData(id);
    } else {
      setSpinningLoading(false);
      message.info("No Details Available, Kindly Try Again...");
    }
    // getAddBookData();
  }, []);

  async function getProductsData(id) {
    // ;
    const getProductData = ds.getProductCommonDetailByProductID({ productID: id }, BEHAVIOUR_TYPE.GET);
    await getProductData
      .then((res) => {
        if (res.status == 200) {
          if (res.data.msgCode == "GENERAL_SUCCESS") {
            setSpinningLoading(false);
            if (res.data.data.productDetails != null) {
              let productCommonData = res.data.data.productDetails;
              setProdName(productCommonData.productName);
              let desc = productCommonData.description
                ? productCommonData.description.replace(/(<([^>]+)>)/gi, "")
                : "";
              setProdDesc(desc ? desc : "");
              setBrandName(productCommonData.brandName);
              let productTagObj =
                productCommonData.productTags &&
                productCommonData.productTags.length &&
                productCommonData.productTags.map((e) => {
                  return { id: e.key, name: e.name };
                });
              if (productTagObj.length != 0) {
                setProdTags(productTagObj);
              }
              setProdInventType(productCommonData.productInventoryType);
              setIsCustomSKU(true);
              setCustomSKUCode(productCommonData.customSKUCode);
              setSupplierID(
                productCommonData.supplierID ? productCommonData.supplierID : 0
              );
              setNoOFVariant(productCommonData.noOfVariants);
              setSupplierCode(productCommonData.supplierCode);
              setSupplierPrice(productCommonData.supplyPrice);
              setIsProdInventory(productCommonData.isProductInventory);
              setOutletInventoryAndTax(
                productCommonData.outletInventoriesandTax
              );
              setCompositeProductsData(productCommonData.compositeProductsData);
              setMarkupInPercentage(productCommonData.markupInPercentage);
              setRetailPrice(productCommonData.retailPrice);
              setIsCustomLoyalty(productCommonData.isCustomLoyalty);
              setName(productCommonData.name);
              setLoyaltyPrice(productCommonData.loyaltyPrice);
              setVariantName(productCommonData.variantName);
              setIsVariant(productCommonData.isVariant);
              setProductVariants(productCommonData.productVariants);
              setVariantAttributes(productCommonData.variantAttributes);

              if (
                productCommonData.productInventoryType != "Standard Product"
              ) {
                ds.getProductOtherDetailByProductID({
                  productID: id,
                  isThumbnailImage: false,
                }, BEHAVIOUR_TYPE.GET).then((res1) => {
                  if (res1.data.msgCode == "GENERAL_SUCCESS") {
                    if (res1.data.data.productDetails != null) {
                      let productOtherData = res1.data.data.productDetails;

                      if (
                        productOtherData.productInventoryType ==
                        "Composite Product"
                      ) {
                        if (
                          productOtherData.compositeProductsData != null &&
                          productOtherData.compositeProductsData.length > 0
                        ) {
                          setCompositeProductsData(
                            productOtherData.compositeProductsData
                          );
                        }
                      }
                      if (
                        productOtherData.productInventoryType ==
                        "Product with Variants"
                      ) {
                        if (
                          productOtherData.productVariants != null &&
                          productOtherData.productVariants.length > 0 &&
                          productOtherData.variantAttributes != null &&
                          productOtherData.variantAttributes.length > 0
                        ) {
                          setProductVariants(productOtherData.productVariants);
                          setVariantAttributes(
                            productOtherData.variantAttributes
                          );
                        }
                      }
                    }
                  }
                });
              }
            } else {
              setSpinningLoading(false);
              message.info("Details not available...");
            }
          } else {
            setSpinningLoading(false);
            message.error("Something Went Wrong...");
          }
        } else {
          setSpinningLoading(false);
          message.error("Something Went Wrong...");
        }
      })
      .catch((e) => {
        notAllowMsgCheck(e);
        setSpinningLoading(false);
      });
  }

  const columns = [
    {
      title: <IntlMessages id="products.productdetail.out" />,
      dataIndex: "outletName",
      key: "outletName",
      render: (text, record) => {
        return (
          <span
            // onClick={() =>
            //   history.push(
            //     `/dashboard/products/pricebook/productdetail/${record.prodid}`
            //   )
            // }
            className="gx-link"
            style={{ fontWeight: "500" }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: <IntlMessages id="products.productdetail.instock" />,
      dataIndex: "currentInventory",
      key: "currentInventory",
      render: (text) => {
        return <span style={{ fontWeight: "500" }}>{text}</span>;
      },
    },
  ];

  const columnsComposite = [
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
      render: (text, record) => {
        return (
          <span
            // onClick={() =>
            //   history.push(
            //     `/dashboard/products/pricebook/productdetail/${record.prodid}`
            //   )
            // }
            className="gx-link"
            style={{ fontWeight: "500" }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "Supply Price",
      dataIndex: "supplyPrice",
      key: "supplyPrice",
      render: (text) => {
        return <span style={{ fontWeight: "500" }}>{text}</span>;
      },
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (text) => {
        return <span style={{ fontWeight: "500" }}>{text}</span>;
      },
    },
  ];

  const columnsProdVariants = [
    {
      title: "",
      dataIndex: "outletName",
      key: "outletName",
      render: (text, record) => {
        return (
          <span className="gx-link" style={{ fontWeight: "500" }}>
            {text}
          </span>
        );
      },
    },
    {
      title: <IntlMessages id="products.productdetail.instock" />,
      dataIndex: "currentInventory",
      key: "currentInventory",
      render: (text) => {
        return <span style={{ fontWeight: "500" }}>{text}</span>;
      },
    },
  ];

  return (
    <div className="Content-wrapper GeneralPriceBook-pg">
      <div className="align-items-center bread-crum">
      <i className="icon icon-charvlet-right mr-1 pt-1" />
          <h3 className="mb-0 mr-3">
          <a href="Dashboard/products/main" className="custm-glinkprimaryclr">
            {<IntlMessages id="products.addpricebook.products" />}
          </a>
        </h3>
        <i className="icon icon-charvlet-right mr-1 pt-1" />
          <h3 className="mb-0 mr-3">
          <a
            href="Dashboard/products/pricebook"
            className="custm-glinkprimaryclr"
          >
            {<IntlMessages id="products.addpricebook.pricebook" />}
          </a>
        </h3>
        <i className="icon icon-charvlet-right mr-1 pt-1" />
          <h3 className="mb-0 mr-3 dk-dark-black">
          <a>{<IntlMessages id="products.addpricebook.productdetail" />}</a>
        </h3>
      </div>

      <Spin
        tip={<IntlMessages id="products.productdetail.loader" />}
        spinning={isSpinningLoading}
        size="large"
      >
        <Card className="gx-card mt-3" title={<h3 className="mt-3 mb-0"><IntlMessages id="products.productdetail.head" /></h3>}>
          <Row>
            <Col md={24}>
              <p>
                <IntlMessages id="products.productdetail.following" />
              </p>
            </Col>
          </Row>

          <Divider />

          <Row className="mt-4">
            <Col md={12}>
              {getProdName && (
                <>
                  <h3 className="dk-dark-black mb-0">Name</h3>
                  <p className="dk-genralpricebook-fnt-size mb-4">{getProdName}</p>
                </>
              )}

              {getProdDesc && (
                <>
                  <h3 className="dk-dark-black mb-0">Description</h3>
                  <p className="dk-genralpricebook-fnt-size mb-4">{getProdDesc}</p>
                </>
              )}

              <h3 className="dk-dark-black mb-0">Type</h3>
              <p className="dk-genralpricebook-fnt-size mb-4">Send Product Type</p>

              {getBrandName && (
                <>
                  <h3 className="dk-dark-black mb-0">Brand</h3>
                  <p className="dk-genralpricebook-fnt-size mb-4">{getBrandName}</p>
                </>
              )}
            </Col>
            <Col md={12}>
              {getSupplierPrice && (
                <>
                  <h2>Supply Price</h2>
                  <p>{getSupplierPrice}</p>
                </>
              )}

              {getRetailPrice && (
                <>
                  <h2>Retail Price</h2>
                  <p>{getRetailPrice}</p>
                </>
              )}

              {getSupplierCode && (
                <>
                  <h2>Supplier Code</h2>
                  <p>{getSupplierCode}</p>
                </>
              )}
            </Col>
          </Row>
        </Card>

        <Card className="gx-card mt-3" title={<h3 className="mt-3 mb-0">Basic Information</h3>}>
          <Divider />
          <Row>
            <Col md={12}>
              {getMarkupInPercentage && (
                <>
                  <h2>Markup Percentage</h2>
                  <p>{getMarkupInPercentage}%</p>
                </>
              )}

              {getLoyaltyPrice && (
                <>
                  <h2>Loyalty Price</h2>
                  <p>{getLoyaltyPrice}</p>
                </>
              )}

              {getName && (
                <>
                  <h2>Custom Name</h2>
                  <p>{getName}</p>
                </>
              )}

              {getCustomSKUCode && (
                <>
                  <h2>SKU</h2>
                  <p>{getCustomSKUCode}</p>
                </>
              )}
            </Col>
            <Col md={12}>
              {getProdInventType && (
                <>
                  <h2>Product Inventory Type</h2>
                  <p>{getProdInventType}</p>
                </>
              )}

              {getVariantName && (
                <>
                  <h2>Variant Name</h2>
                  <p>{getVariantName}</p>
                </>
              )}

              {getNoOFVariant && (
                <>
                  <h2>Number of Variants</h2>
                  <p>{getNoOFVariant}</p>
                </>
              )}
            </Col>
          </Row>
        </Card>

        {getProdTags && getProdTags.length > 0 && (
          <Card className="gx-card" title="Product Tags">
            <div className="gx-module-box-content">
              {getProdTags.map((e, key) => {
                return (
                  <div key={key} className="gx-module-list-item">
                    <div className="gx-module-list-icon">
                      <i className="gx-icon-btn icon icon-star" />
                    </div>
                    <div className="gx-module-list-info">
                      <div className="gx-module-todo-content">
                        <div
                          className={`gx-subject ${false && "gx-text-muted gx-text-strikethrough"
                            }`}
                        >
                          {e.name}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Card>
        )}

        {getOutletInventoryAndTax && getOutletInventoryAndTax.length > 0 && (
          <Card className="gx-card" title="INVENTORY">
            <Table
              className="gx-table-responsive"
              columns={columns}
              dataSource={getOutletInventoryAndTax}
            />
          </Card>
        )}

        {getCompositeProductsData && getCompositeProductsData.length > 0 && (
          <Card className="gx-card" title="COMPOSITE PRODUCT INFORMATION">
            <Table
              className="gx-table-responsive"
              columns={columnsComposite}
              dataSource={getCompositeProductsData}
            />
          </Card>
        )}
      </Spin>
    </div>
  );
};

export default ProductDetail;
